module.exports = __webpack_public_path__ + "static/media/expedia.1f4a3c27.svg";